<div class="page" [contextMenuTrigger]="menu"
[menuContext]="{ value: InvCreateInVoucherSetting, visible: formVisible, settingChanges$: settingChanges$ }"
(menuAction)="($event)">
  <kgrid
    [apiName]="apiName"
    [areaName]="areaName"
    [label]="label"
    [name]="apiName"
    pathPreFix="SALE"
    [isMulti]="true"
    [inputEditorform]="inputEditorform"
    [isEdit]="false"
    defaultSortKey="Code"
    [isDelete]="isDelete">
  </kgrid>
</div>
